import { useDbClient, useLiveQuery } from "@tanstack/react-db";
import {
  collectionError,
  refreshCollections,
} from "@softmax/web-features/data";
import { requestUnavailable } from "@softmax/observatory-client/transport";
import { experienceRequestsPageCollections } from "@/features/research/records";

export function usePracticeSearch({ enabled }: { readonly enabled: boolean }) {
  const client = useDbClient();
  const practiceSources = experienceRequestsPageCollections({
    filters: { mine: true },
    selection: {},
    cursor: null,
    limit: 50,
    elevatedPrivileges: false,
  });
  const practice = useLiveQuery((q) =>
    enabled
      ? q
          .from({ request: practiceSources.requests })
          .orderBy(({ request }) => request.created_at, "desc")
          .orderBy(({ request }) => request.id, "desc")
      : undefined,
  );
  const practicePage = useLiveQuery((q) =>
    enabled ? q.from({ page: practiceSources.page }).findOne() : undefined,
  );
  const practiceError =
    collectionError(practice.health) ?? collectionError(practicePage.health);
  const practiceRows = requestUnavailable(practiceError)
    ? []
    : (practice.data ?? []);
  return {
    rows: practiceRows,
    state: {
      isPending: practice.isLoading || practicePage.isLoading,
      isError: practiceError !== null,
      refetch: () =>
        refreshCollections({
          queries: [practice.collection, practicePage.collection],
          signal: client.requireDependency<AbortController>("lifetime").signal,
          refresh: () =>
            client
              .collection(practiceSources.requests)
              .utils.refetch({ throwOnError: true }),
        }),
    },
  };
}
